import Delete from "./Cells/Delete";
import Email from "./Cells/Email";

type Col = {
	id: string;
	Cell: (transaction: any) => JSX.Element | null;
	label: string;
	align?: "center" | "left";
};

const cols: Col[] = [
	{
		id: "email",
		Cell: Email,
		label: "Nombre",
		align: "left"
	},
	{
		id: "delete",
		Cell: Delete,
		align: "center",
		label: ""
	}
];

export default cols;
